<template>
  <div class="war-room-pinned-post">
    <div class="war-room-pinned-post__info">
      <WarRoomCategoryBadge :post="post" data-test="post_preview_topic" class="war-room-pinned-post__topic" />
      <SignUpWallLink :to="link" data-test="post_preview_title" link-class="war-room-pinned-post__title">
        <BravadoText tag="span" variant="subhead-semibold" variant-sm="body-semibold">
          {{ post.content.data.title }}
        </BravadoText>
      </SignUpWallLink>
      <SignUpWallLink :to="`${link}?comment=true`" link-class="war-room-pinned-post__comment">
        <CommentIcon width="16" height="16" class="war-room-pinned-post__icon" />
        <BravadoText variant="subhead-semibold">{{ post.comment_count.total || 'Comment' }}</BravadoText>
      </SignUpWallLink>
    </div>
    <WarRoomPostActions v-if="isAdmin" :post="post" class-name="war-room-pinned-post__menu" />
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import CommentIcon from './images/preview-comment.vue.svg';
import type { IPost } from '@/types/community';
import BravadoText from '@/components/common/BravadoText/BravadoText.vue';
import SignUpWallLink from '@/components/common/SignUpWallLink.vue';
import WarRoomCategoryBadge from '@/components/partials/war-room/WarRoomCategoryBadge/WarRoomCategoryBadge.vue';
import WarRoomPostActions from '@/components/partials/war-room/WarRoomPostActions.vue';
import warRoomSignUpMixin from '@/components/partials/war-room/WarRoomSignUp/warRoomSignUpMixin';

export default Vue.extend({
  name: 'WarRoomPinnedPost',
  components: {
    BravadoText,
    CommentIcon,
    SignUpWallLink,
    WarRoomPostActions,
    WarRoomCategoryBadge,
  },
  mixins: [warRoomSignUpMixin],
  props: {
    post: {
      type: Object,
      required: true,
    } as PropOptions<IPost>,
  },
  computed: {
    ...mapGetters('warRoom', ['isAdmin']),
    link(): string {
      return `${this.$pages.POSTS_PAGE.path}/${this.post.slug}`;
    },
  },
});
</script>

<style scoped lang="scss">
.war-room-pinned-post {
  display: flex;
  align-items: center;

  & + & {
    margin-top: 6px;
  }

  &__info {
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
  }

  &__title {
    color: var(--theme-color-text);
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__comment {
    text-decoration: none;
    display: flex;
    align-items: center;
    margin-left: 2px;
    padding: 0 5px;
    color: var(--theme-color-sub-text);
    border-radius: 4px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: var(--theme-sub_text-hover);
    }
  }

  &__topic {
    padding: 4px 5px;
    margin-right: 8px;
  }

  &__icon {
    margin-right: 6px;
  }

  ::v-deep &__menu {
    line-height: 0;
    color: var(--gray-50);
    margin: 5px 0 0 10px;
    position: relative;
    z-index: 2;

    &:hover {
      color: rgba(var(--black));
    }
  }
}
</style>
